import data from "../assets/agenda_depr.json";

function Agenda() {
  return (
    <>
      <div className="content_container agenda_container">
        <h1>Agenda</h1>
        Vivamus id ipsum a augue ornare facilisis quis a leo. Vestibulum ante
        ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae;
        Nulla dapibus tellus ultricies tellus congue finibus. Duis nec sem orci.
        Fusce arcu eros, consequat nec varius vel, lobortis quis magna. Sed ac
        magna risus. Nullam egestas iaculis condimentum. Pellentesque nunc arcu,
        convallis ac ligula id, dignissim porttitor ligula. Phasellus nec leo
        sapien. Etiam convallis at libero sed accumsan. Cras varius erat a
        finibus vestibulum. Quisque cursus commodo velit sit amet commodo.
        Vestibulum quis varius ante. Fusce suscipit scelerisque dapibus. Sed leo
        lorem, euismod in lobortis id, lobortis quis purus.
        <div>
          {/* {Array.from({ length: data.length }).map((_, index) => (
            <AgendaCard key={index} data={data}></AgendaCard>
          ))} */}
          {data.map((data) => (
            <AgendaCard
              key={data.key}
              title={data.title}
              image={data.image}
              summary={data.summary}
            />
          ))}
        </div>
      </div>
    </>
  );
}

function AgendaCard({ title, image, summary }) {
  return (
    <>
      <div>
        <h2>{title}</h2>
        <img className="landing__logo__image" src={image} alt=""></img>
        <p>{summary}</p>
      </div>
    </>
  );
}

export default Agenda;
